import { render, staticRenderFns } from "./ConfirmModalBootstrapVue.vue?vue&type=template&id=6e6ac266&"
import script from "./ConfirmModalBootstrapVue.vue?vue&type=script&lang=js&"
export * from "./ConfirmModalBootstrapVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports